module.exports = __webpack_public_path__ + "img/invest.cc529f31.svg";